import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useProtocolCategoryMutations } from '../../../hooks/useNomenclatures';

const ProtocolCategoryList = ({ items, onUpdate }) => {
  const mutations = useProtocolCategoryMutations();

  const fields = [
    { name: 'icon', label: 'Icon', type: 'text', placeholder: '🧼' },
    { name: 'color', label: 'Color', type: 'color' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="protocol-categories"
      title="Protocol Categories"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default ProtocolCategoryList;

